import { FileTextIcon, ZapIcon, BotIcon, ClipboardCopyIcon, InfinityIcon } from 'lucide-react';

export const heroChips = [{
  icon: FileTextIcon,
  label: '100% Digital PDF'
}, {
  icon: ZapIcon,
  label: 'Instant Download'
}, {
  icon: BotIcon,
  label: 'Compatible with ChatGPT, Claude, Gemini & DeepSeek'
}, {
  icon: ClipboardCopyIcon,
  label: 'Ready-to-Use Copy-and-Paste Prompts'
}, {
  icon: InfinityIcon,
  label: 'Lifetime Access to Your Purchased Materials'
}];

export const heroPillars = 'Daily Planning · Team Coordination · Task Delegation · Performance Tracking · Reporting · Problem-Solving · Communication';

export const stats = [{
  value: '300+',
  label: 'Supervisors'
}, {
  value: '6+5',
  label: 'Volumes + Bonuses'
}, {
  value: '99%',
  label: 'Recommend it'
}, {
  value: '4.9/5',
  label: '⭐ Global Rating'
}];
